import { render, staticRenderFns } from "./nav-learning-worldwide-popover.vue?vue&type=template&id=3ed5ff8a"
import script from "./nav-learning-worldwide-popover.ts?vue&type=script&lang=ts&external"
export * from "./nav-learning-worldwide-popover.ts?vue&type=script&lang=ts&external"
import style0 from "./nav-learning-worldwide-popover.scss?vue&type=style&index=0&prod&lang=scss&scope=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports